import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50d7bf99"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["video-id", "id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "video-id": _ctx.vitrine.data_src,
        class: "youtube-player-container",
        id: _ctx.id
    }, null, 8, _hoisted_1));
}
